import { OwaDate, startOfDay, addDays } from 'owa-datetime';
import { OwaDateRange } from 'owa-datetime-utils/lib/OwaDateRange';

export default function getAdjustedEventTime(
    start: OwaDate,
    end: OwaDate,
    isAllDay: boolean
): OwaDateRange {
    let adjustedStart = start;
    let adjustedEnd = end;

    if (isAllDay) {
        adjustedStart = startOfDay(start);
        adjustedEnd = startOfDay(addDays(end, 1));
    }

    return { start: adjustedStart, end: adjustedEnd };
}
